<template>
  <div class="flex flex-wrap gap-4 mt-6 mb-12">
    <div class="bg-white w-[99%] m-auto shadow-ts1 rounded-lg pb-8">
      <div class="px-6 py-5 border-b border-gray-400 flex justify-between items-center">
        <h2 class="font-display text-xl font-bold text-blue leading-none">{{ $t('alpha_generation').tTitle() }}</h2>
        <a target="_blank" :href="`${websiteURL}tools/alpha-generation-plugin/user-guides/`" class="w-28 py-0.5 table text-black font-medium text-center text-sm"
          >{{ $t('view_guides').tTitle() }}
        </a>
      </div>
      <div class="w-full border-b border-gray-300 px-4 md:px-8 pt-5 pb-4">
        <div class="grid grid-cols-1-default md:grid-cols-3-default gap-7 sm:w-full xl:w-[85%] m-auto justify-center">
          <p class="text-gray-900 text-sm leading-6 text-center font-bold text-[16px] md:col-span-3" v-html="$t('alpha_generation_text')"></p>
          <div class="card flex flex-col">
            <p class="card-title text-white text-[28px] leading-10 text-center" v-html="$t('trusted_source')"></p>
            <img src="../../assets/img/alpha-generation-1.svg" loading="lazy" />
            <p class="card-description text-white text-[16px] leading-7 text-center">{{ $t('trusted_source_description') }}</p>
          </div>
          <div class="card flex flex-col">
            <p class="card-title text-white text-[28px] leading-10 text-center" v-html="$t('simple_vuew')"></p>
            <img src="../../assets/img/alpha-generation-2.svg" loading="lazy" />
            <p class="card-description text-white text-[16px] leading-7 text-center">{{ $t('simple_vuew_description') }}</p>
          </div>
          <div class="card flex flex-col">
            <p class="card-title text-white text-[28px] leading-10 text-center" v-html="$t('shorter_length')"></p>
            <img src="../../assets/img/alpha-generation-3.svg" loading="lazy" />
            <p class="card-description text-white text-[16px] leading-7 text-center">{{ $t('shorter_length_description') }}</p>
          </div>
          <div class="m-auto text-center md:col-span-3">
            <a
              href="https://mt.tradingcentral.com/download"
              target="_blank"
              class="text-center text-white rounded-md py-3 px-4 text-base font-bold table mt-6 mb-4 relative z-10 bg-green"
            >
              {{ $t('download_the_plugin') }}
            </a>
            <a target="_blank" :href="`${websiteURL}tools/alpha-generation-plugin/`" class="m-auto mt-4 mb-[30px] w-28 py-0.5 table text-black text-center text-sm font-medium"
              >{{ $t('learn_more').tTitle() }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '@/main.js'
import { mapGetters, mapActions } from 'vuex'
import config from '../../config'

export default {
  data() {
    return {
      iframeURL: '',
      websiteURL: config.URL.website,
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      logoLoaderActive: 'logoLoader/active',
    }),
  },
  beforeMount() {},
  mounted() {
    this.getIframeURL()
  },
  watch: {},
  created() {},
  methods: {
    getIframeURL() {
      // this['logoLoader/set'](true)
      service
        .post('/tradingcentral/handshake', {
          user: this.User.info.ID.toString(),
          page: 'av_ideas',
        })
        .then(response => {
          // this['logoLoader/set'](false)
          this.iframeURL = response.data
        })
        .catch(error => {
          // this['logoLoader/set'](false)
          console.log(error)
          this.$toasted.error(this.$t('something_went_wrong'))
        })
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>
<style scoped>
.card {
  min-width: 30%;
  /* min-height: 450px; */
  padding: 24px 33px;
  background: transparent linear-gradient(180deg, #2b63e3 0%, #2d394b 100%) 0% 0% no-repeat padding-box;
  border-radius: 8px;
}
.card:nth-child(3) {
  background: transparent linear-gradient(0deg, #2b63e3 0%, #2d394b 100%) 0% 0% no-repeat padding-box;
}
.card img {
  margin: auto;
  height: 168px !important;
}
</style>
